(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = initAdmin

var createController = require('./controllers/controller')

function initAdmin () {
  return { officeAdmin: init }
}

function init (serviceLocator, done) {

  createController(serviceLocator)
  done()
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/office/init.js","/components/admin/office")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vb2ZmaWNlL2luaXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0gaW5pdEFkbWluXG5cbnZhciBjcmVhdGVDb250cm9sbGVyID0gcmVxdWlyZSgnLi9jb250cm9sbGVycy9jb250cm9sbGVyJylcblxuZnVuY3Rpb24gaW5pdEFkbWluICgpIHtcbiAgcmV0dXJuIHsgb2ZmaWNlQWRtaW46IGluaXQgfVxufVxuXG5mdW5jdGlvbiBpbml0IChzZXJ2aWNlTG9jYXRvciwgZG9uZSkge1xuXG4gIGNyZWF0ZUNvbnRyb2xsZXIoc2VydmljZUxvY2F0b3IpXG4gIGRvbmUoKVxufVxuIl19